export const domainLogos = {
  "localhost": "/logos/sportarena.png",
  "betzone24.com": "/logos/betzon.png",
  "betsclub.co": "/logos/betsclub.png",
  "bet90.plus": "/logos/90pluss.png",
  "floybet.com": "/logos/floybet.png",
  "sportarena355.com": "/logos/sportarena.png",
}